type PimoEvent<EventType, EventPayload> = {
  type: EventType;
  payload?: EventPayload;
};

type PimoEventHandler<EventType, EventPayload> = (
  event: PimoEvent<EventType, EventPayload>
) => void | Promise<void>;

/** Components and Routes fire events i.e click|hover for components and load for routes */
export class EventEmitter<EventType, EventPayload = undefined> {
  private readonly _handlers: {
    eventType: EventType;
    handler: PimoEventHandler<EventType, EventPayload>;
  }[] = [];

  /** the event handling mechanism, that takes an event type and a function that will be triggered accordingly */
  public on(
    eventType: EventType,
    handler: PimoEventHandler<EventType, EventPayload>
  ) {
    this._handlers.push({
      eventType,
      handler,
    });
  }

  public off(handler: PimoEventHandler<EventType, EventPayload>) {
    const handlerIndex = this._handlers.findIndex(
      ({ handler: registeredHandler }) => registeredHandler === handler
    );

    if (handlerIndex === -1) {
      return;
    }

    this._handlers.splice(handlerIndex, 1);
  }

  /** the event triggering mechanism by a route change/click/hover etc */
  public fireEvent(eventType: EventType, payload?: EventPayload): void {
    this._handlers
      .filter((handler) => handler.eventType === eventType)

      .forEach((handler) =>
        handler.handler({
          type: eventType,
          payload,
        })
      );
  }
}
